import React, { useState, useEffect, useMemo } from "react";
import Modal from "react-bootstrap/Modal";
import DateTimePicker from "components/GenericComponent/DateTimePicker";
import { convertDate, formatDayMonth } from "../../../../utils/formatDate";
import { pushNotification } from "../../../../utils/notifications";
import userApi from "service/userApi";
import QuanLyCongViecApi from "service/QuanLyCongViec/QuanLyCongViecApi";
import { ModalChonHopDong } from "../ChonHopDong/index";
import ReactDropdown from "react-dropdown";

const initialFormData = {
    WorkCode: "",
    Title: "",
    Content: "",
    AssignedToName: "",
    StartDate: new Date(),
    EndDate: null,
    ContractCode: "",
    EvaluationCode: 0,
    Reason: "",
    EvaluationComment: "",
    AssignedByName: "",
};

const evaluationMap = {
    0: "Chưa có",
    1: "Hoàn thành",
    2: "Không hoàn thành",
};

export const ModalTask = ({ mode, item, show, onHide, onSaved }) => {
    const [formData, setFormData] = useState(initialFormData);
    const [isLoading, setIsLoading] = useState(false);
    const [isSubmit, setIsSubmit] = useState(false);
    const [nhanVienOptions, setNhanVienOptions] = useState([]);
    const [chuOptions, setChuOptions] = useState([]);
    const [quanLyOptions, setQuanLyOptions] = useState([]);
    const [selectedRole, setSelectedRole] = useState('shopadmin');
    const [showHopDongModal, setShowHopDongModal] = useState(false);
    const [hideParent, setHideParent] = useState(false);
    const [dropdownsLoaded, setDropdownsLoaded] = useState(false);

    const handleOpenModalChonHopDong = () => {
        setShowHopDongModal(true);
        setHideParent(true);
    };
    const handleCloseModalChonHopDong = () => {
        setShowHopDongModal(false);
        setHideParent(false);
    };
    const evaluationDropdownOptions = useMemo(() =>
        Object.entries(evaluationMap).map(([value, label]) => ({
            value: parseInt(value, 10), label
        })), []);

    const roleOptions = useMemo(() => [
        { value: "shopadmin", label: "Chủ" },
        { value: "shopmanager", label: "Quản lý" }
    ], []);

    const placeholderNhanVien = { value: "", label: "-- Chọn nhân viên --" };
    const placeholderNguoiGiao = { value: "", label: "-- Chọn người giao --" };
    const memoizedNhanVienOptions = useMemo(() => [placeholderNhanVien, ...nhanVienOptions], [nhanVienOptions]);
    const memoizedChuOptions = useMemo(() => [placeholderNguoiGiao, ...chuOptions], [chuOptions]);
    const memoizedQuanLyOptions = useMemo(() => [placeholderNguoiGiao, ...quanLyOptions], [quanLyOptions]);
    const { title, submitText, iconSrc } = useMemo(() => {
        switch (mode) {
            case 'create': return { title: 'Thêm mới công việc', submitText: 'THÊM MỚI', iconSrc: "/app-assets/images/icon-tao-moi-don-nhap-hang.png" };
            case 'update': return { title: 'Sửa công việc', submitText: 'CẬP NHẬT', iconSrc: "/app-assets/images/icon-editphieuthuchi.png" };
            case 'extend': return { title: 'Gia hạn công việc', submitText: 'GIA HẠN', iconSrc: "/app-assets/images/icon-editphieuthuchi.png" };
            case 'reassign': return { title: 'Giao việc cho người khác', submitText: 'GIAO VIỆC', iconSrc: "/app-assets/images/icon-editphieuthuchi.png" };
            default: return { title: '', submitText: '', iconSrc: '' };
        }
    }, [mode]);

    const isEditable = (fieldName) => {
        if (mode === 'create') return true;
        if (mode === 'update') return true;
        if (mode === 'extend' && ['EndDate', 'Content'].includes(fieldName)) return true;
        if (mode === 'reassign' && ['AssignedToName', 'StartDate', 'EndDate'].includes(fieldName)) return true;
        return false;
    };

    useEffect(() => {
        const loadAllDropdowns = async () => {
            try {
                const [chuRes, qlyRes, nvRes] = await Promise.all([
                    userApi.getUserRoleDropdown({ role: 'shopadmin' }),
                    userApi.getUserRoleDropdown({ role: 'shopmanager' }),
                    userApi.combo2()
                ]);

                if (chuRes.status === 200 && chuRes.data) {
                    const formattedOptions = chuRes.data.map(user => ({ value: user.UserName, label: user.FullName }));
                    setChuOptions(formattedOptions);
                }

                if (qlyRes.status === 200 && qlyRes.data) {
                    const formattedOptions = qlyRes.data.map(user => ({ value: user.UserName, label: user.FullName }));
                    setQuanLyOptions(formattedOptions);
                }

                if (nvRes.status === 200 && nvRes.data) {
                    setNhanVienOptions(nvRes.data || []);
                }
                setDropdownsLoaded(true);
            } catch (error) {
                console.error("Lỗi khi tải dữ liệu cho các dropdown:", error);
            }
        };
        loadAllDropdowns();
    }, []);

    useEffect(() => {
        if (!show) return;

        if (mode !== 'create' && item && item.Id && dropdownsLoaded) {
            setIsLoading(true);
            QuanLyCongViecApi.getTaskById(item.Id)
                .then(res => {
                    if (res.status === 200) {
                        const task = res.data;
                        const assigneeNameFromApi = task.AssignedToName;
                        let assigneeValue = '';
                        let matchingNhanVien = nhanVienOptions.find(opt => opt.value === assigneeNameFromApi);
                        if (!matchingNhanVien && assigneeNameFromApi) {
                            const apiNameToCompare = assigneeNameFromApi.trim().toLowerCase();
                            matchingNhanVien = nhanVienOptions.find(opt =>
                                (opt.label || '').trim().toLowerCase() === apiNameToCompare
                            );
                        }
                        if (matchingNhanVien) {
                            assigneeValue = matchingNhanVien.value;
                        }
                        const assignerNameFromApi = task.AssignedByName;
                        let assignerValue = '';
                        let foundRole = 'shopadmin';
                        const allAssigners = [...chuOptions, ...quanLyOptions];
                        let matchingAssigner = allAssigners.find(opt => opt.value === assignerNameFromApi);

                        if (!matchingAssigner && assignerNameFromApi) {
                            const apiNameToCompare = assignerNameFromApi.trim().toLowerCase();
                            matchingAssigner = allAssigners.find(opt =>
                                (opt.label || '').trim().toLowerCase() === apiNameToCompare
                            );
                        }

                        if (matchingAssigner) {
                            assignerValue = matchingAssigner.value;
                            if (quanLyOptions.some(opt => opt.value === assignerValue)) {
                                foundRole = 'shopmanager';
                            } else {
                                foundRole = 'shopadmin';
                            }
                        } else {
                            assignerValue = '';
                        }
                        setSelectedRole(foundRole);
                        setFormData({
                            WorkCode: task.WorkCode || '',
                            Title: task.Title || '',
                            Content: task.Content || '',
                            AssignedToName: assigneeValue,
                            StartDate: task.StartDate ? convertDate(task.StartDate) : null,
                            EndDate: task.EndDate ? convertDate(task.EndDate) : null,
                            ContractCode: task.ContractCode || '',
                            EvaluationCode: 0,
                            Reason: "",
                            EvaluationComment: "",
                            AssignedByName: assignerValue,
                        });
                    }
                })
                .finally(() => setIsLoading(false));
        } else if (mode === 'create' && dropdownsLoaded) {
            setSelectedRole('shopadmin');
            if (nhanVienOptions.length > 0 && chuOptions.length > 0) {
                setFormData({
                    ...initialFormData,
                    AssignedToName: nhanVienOptions[0]?.value || '',
                    AssignedByName: chuOptions[0]?.value || ''
                });
            } else {
                setFormData(initialFormData);
            }
        }
    }, [item, mode, show, dropdownsLoaded]);

    const handleInputChange = (e) => {
        const { name, value } = e.target;
        setFormData(prev => ({ ...prev, [name]: value }));
    };

    const handleDropdownChange = (name, option) => {
        setFormData(prev => ({ ...prev, [name]: option.value }));
    };

    const handleRoleChange = (option) => {
        setSelectedRole(option.value);
        if (option.value === 'shopadmin' && chuOptions.length > 0) {
            setFormData(prev => ({ ...prev, AssignedByName: chuOptions[0]?.value || '' }));
        } else if (option.value === 'shopmanager' && quanLyOptions.length > 0) {
            setFormData(prev => ({ ...prev, AssignedByName: quanLyOptions[0]?.value || '' }));
        } else {
            setFormData(prev => ({ ...prev, AssignedByName: '' }));
        }
    };

    const handleDateChange = (field, date) => {
        setFormData(prev => ({ ...prev, [field]: date }));
    };

    const handleContractSelect = (selectedContract) => {
        if (selectedContract) {
            setFormData(prev => ({ ...prev, ContractCode: selectedContract.MaHopDong }));
        }
        setShowHopDongModal(false);
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsSubmit(true);
        let res;

        const payload = {
            ...formData,
            StartDate: formData.StartDate ? formatDayMonth(formData.StartDate) : null,
            EndDate: formData.EndDate ? formatDayMonth(formData.EndDate) : null,
        };

        if (mode === 'update') {
            payload.EvaluationHistory = [{
                Reason: formData.Reason,
                Comment: formData.EvaluationComment,
                Status: parseInt(formData.EvaluationCode, 10)
            }];
        }

        try {
            switch (mode) {
                case 'create':
                    res = await QuanLyCongViecApi.createTask(payload);
                    break;
                case 'update':
                    res = await QuanLyCongViecApi.updateTask(item.Id, payload);
                    break;
                case 'extend':
                    res = await QuanLyCongViecApi.extendTask(item.Id, { EndDate: payload.EndDate, Content: payload.Content });
                    break;
                case 'reassign':
                    res = await QuanLyCongViecApi.reassignTask(item.Id, { AssignedToName: payload.AssignedToName, StartDate: payload.StartDate, EndDate: payload.EndDate });
                    break;
                default:
                    throw new Error("Chế độ không hợp lệ");
            }

            if (res.status === 200 || res.status === 201) {
                pushNotification("Thao tác thành công!", "success", "TOP_CENTER", 2000);
                onSaved();
            } else {
                pushNotification("Thao tác thất bại!", "error", "TOP_CENTER", 2000);
            }
        } catch (error) {
            console.error("Lỗi khi submit:", error);
            pushNotification("Đã xảy ra lỗi!", "error", "TOP_CENTER", 2000);
        } finally {
            setIsSubmit(false);
        }
    };

    return (
        <>
            <Modal show={show && !hideParent} onHide={onHide} size="xl" centered backdrop="static" className="modal-new modal fade text-left">
                <Modal.Header>
                    <h4 className="modal-title color7-bold">
                        <span className="btn-icon-right"><img
                            src={iconSrc}
                            alt="icon"
                        /></span>
                        {title}
                    </h4>
                    <button type="button" className="close-popup-new" onClick={onHide} disabled={isSubmit}>
                        <img src="/app-assets/images/icon-dong-popup-v2.png" alt="close" />
                    </button>
                </Modal.Header>
                {(isLoading || !dropdownsLoaded) ? <div className="p-5 text-center">Đang tải dữ liệu...</div> : (
                    <form onSubmit={handleSubmit}>
                        <Modal.Body>
                            <div className="form form-horizontal">
                                <div className="form-body">
                                    <strong className="label-control color7-bold">I. Thông tin công việc</strong>
                                    <div className="row mt-2">
                                        <div className="form-group col-md-4"><label className="label-control color7-bold">Mã công việc</label><input type="text" className="form-control input-sm" readOnly value={formData.WorkCode || ""} /></div>
                                        <div className="form-group col-md-4">
                                            <label className="label-control color7-bold">Nhân viên nhận việc</label>
                                            {isEditable('AssignedToName') ? (
                                                <ReactDropdown
                                                    options={memoizedNhanVienOptions}
                                                    onChange={(option) => handleDropdownChange('AssignedToName', option)}
                                                    value={memoizedNhanVienOptions.find(opt => opt.value === formData.AssignedToName) || placeholderNhanVien}
                                                    controlClassName="form-control input-sm"
                                                />
                                            ) : (
                                                <input type="text" className="form-control input-sm" readOnly value={memoizedNhanVienOptions.find(opt => opt.value === formData.AssignedToName)?.label || '---'} />
                                            )}
                                        </div>
                                        <div className="form-group col-md-4"><label className="label-control color7-bold">Liên quan đến hợp đồng</label>
                                            <div className="input-group">
                                                <input type="text" name="ContractCode" value={formData.ContractCode || ""} onChange={handleInputChange} className="form-control input-sm" readOnly />
                                                {isEditable('ContractCode') &&
                                                    <div className="input-group-append">
                                                        <button className="btn btn-info btn-sm" type="button" onClick={handleOpenModalChonHopDong}>Chọn</button>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        <div className="form-group col-md-4"><label className="label-control color7-bold">Ngày bắt đầu</label>
                                            <DateTimePicker
                                                value={formData.StartDate}
                                                onChange={date => handleDateChange('StartDate', date)}
                                                readOnly={!isEditable('StartDate')}
                                            />
                                        </div>
                                        <div className="form-group col-md-4"><label className="label-control color7-bold">Ngày kết thúc</label>
                                            <DateTimePicker
                                                value={formData.EndDate}
                                                onChange={date => handleDateChange('EndDate', date)}
                                                minDate={formData.StartDate}
                                                readOnly={!isEditable('EndDate')}
                                            />
                                        </div>
                                        <div className="form-group col-md-4"><label className="label-control color7-bold">Tên công việc <span className="canh-bao-red">*</span></label><input type="text" name="Title" value={formData.Title} onChange={handleInputChange} className="form-control input-sm" required readOnly={!isEditable('Title')} /></div>
                                        <div className="form-group col-md-12"><label className="label-control color7-bold">Nội dung công việc</label><textarea name="Content" value={formData.Content} onChange={handleInputChange} className="form-control1 input-sm" rows="3" readOnly={!isEditable('Content')} style={{ minWidth: "100%" }}></textarea></div>
                                    </div>

                                    <hr />
                                    <strong className="label-control color7-bold">II. Người giao việc</strong>
                                    <div className="row mt-2">
                                        <div className="form-group col-md-6">
                                            <label className="label-control color7-bold">Chức vụ</label>
                                            {isEditable('AssignedByName') ? (
                                                <ReactDropdown
                                                    options={roleOptions}
                                                    onChange={handleRoleChange}
                                                    value={roleOptions.find(opt => opt.value === selectedRole)}
                                                    controlClassName="form-control input-sm"
                                                />
                                            ) : (
                                                <input type="text" className="form-control input-sm" readOnly value={roleOptions.find(opt => opt.value === selectedRole)?.label || '---'} />
                                            )}
                                        </div>
                                        <div className="form-group col-md-6">
                                            <label className="label-control color7-bold">Người giao việc</label>
                                            {isEditable('AssignedByName') ? (
                                                <ReactDropdown
                                                    options={(selectedRole === 'shopadmin' ? memoizedChuOptions : memoizedQuanLyOptions)}
                                                    onChange={(option) => handleDropdownChange('AssignedByName', option)}
                                                    value={(selectedRole === 'shopadmin' ? memoizedChuOptions : memoizedQuanLyOptions).find(opt => opt.value === formData.AssignedByName) || placeholderNguoiGiao}
                                                    controlClassName="form-control input-sm"
                                                />
                                            ) : (
                                                <input type="text" className="form-control input-sm" readOnly value={(selectedRole === 'shopadmin' ? memoizedChuOptions : memoizedQuanLyOptions).find(opt => opt.value === formData.AssignedByName)?.label || '---'} />
                                            )}
                                        </div>
                                    </div>

                                    {mode === 'update' && (
                                        <>
                                            <hr />
                                            <strong className="label-control color7-bold">III. Nhận xét & Đánh giá</strong>
                                            <div className="row mt-2">
                                                <div className="form-group col-md-6">
                                                    <label className="label-control color7-bold">Đánh giá</label>
                                                    <ReactDropdown
                                                        options={evaluationDropdownOptions}
                                                        onChange={(option) => handleDropdownChange('EvaluationCode', option)}
                                                        value={evaluationDropdownOptions.find(opt => opt.value === formData.EvaluationCode)}
                                                        controlClassName="form-control input-sm"
                                                        disabled={!isEditable('EvaluationCode')}
                                                    />
                                                </div>
                                                <div className="form-group col-md-6"><label className="label-control color7-bold">Lý do không hoàn thành</label>
                                                    <textarea name="Reason" value={formData.Reason} onChange={handleInputChange} className="form-control1 input-sm" rows="1" readOnly={!isEditable('Reason')} style={{ minWidth: "100%" }}></textarea>
                                                </div>
                                                <div className="form-group col-md-12"><label className="label-control color7-bold">Nhận xét</label>
                                                    <textarea name="EvaluationComment" value={formData.EvaluationComment} onChange={handleInputChange} className="form-control1 input-sm" rows="3" readOnly={!isEditable('EvaluationComment')} style={{ minWidth: "100%" }}></textarea>
                                                </div>
                                            </div>
                                        </>
                                    )}
                                </div>
                            </div>
                        </Modal.Body>
                        <Modal.Footer>
                            <button type="button" className="btn btn-new-main btn-closenew" onClick={onHide} disabled={isSubmit}>
                                <span><i className="mdi mdi-close"></i></span>&nbsp; Đóng
                            </button>
                            <button type="submit" className="btn btn-new-main button-popup-submit" disabled={isSubmit}>
                                <span><img src="/app-assets/images/icon-send-v2.png" alt="save" /></span>&nbsp; {isSubmit ? "Đang xử lý..." : submitText}
                            </button>
                        </Modal.Footer>
                    </form>
                )}
            </Modal>
            {showHopDongModal && (
                <ModalChonHopDong
                    show={showHopDongModal}
                    onHide={handleCloseModalChonHopDong}
                    onContractSelected={handleContractSelect}
                />
            )}
        </>
    );
};